module.exports = __webpack_public_path__ + "index/img/fuzhilianjie.66f0379b.png";